/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';

/**
 * 
 * @export
 * @interface AttendeeReportParams
 */
export interface AttendeeReportParams {
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    primary_contact_id: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_full_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_last_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    is_connected: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    is_archived: string;
    /**
     * 
     * @type {number}
     * @memberof AttendeeReportParams
     */
    attendee_age: number;
    /**
     * 
     * @type {Gender}
     * @memberof AttendeeReportParams
     */
    attendee_gender: Gender;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_date_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    primary_contact_full_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    primary_contact_email: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    primary_contact_phones: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    primary_contact_address_place_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    parent_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_emergency_contact_email: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    attendee_emergency_contact_phone: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    active_membership_package_name: string;
    /**
     * 
     * @type {string}
     * @memberof AttendeeReportParams
     */
    session_balance: string;
    /**
     * 
     * @type {Date}
     * @memberof AttendeeReportParams
     */
    first_attended?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AttendeeReportParams
     */
    last_attended?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AttendeeReportParams
     */
    last_registered?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AttendeeReportParams
     */
    created: Date;
}

export function AttendeeReportParamsFromJSON(json: any): AttendeeReportParams {
    return AttendeeReportParamsFromJSONTyped(json, false);
}

export function AttendeeReportParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendeeReportParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'primary_contact_id': json['primary_contact_id'],
        'attendee_full_name': json['attendee_full_name'],
        'attendee_first_name': json['attendee_first_name'],
        'attendee_last_name': json['attendee_last_name'],
        'is_connected': json['is_connected'],
        'is_archived': json['is_archived'],
        'attendee_age': json['attendee_age'],
        'attendee_gender': GenderFromJSON(json['attendee_gender']),
        'attendee_date_of_birth': json['attendee_date_of_birth'],
        'primary_contact_full_name': json['primary_contact_full_name'],
        'primary_contact_email': json['primary_contact_email'],
        'primary_contact_phones': json['primary_contact_phones'],
        'primary_contact_address_place_name': json['primary_contact_address_place_name'],
        'parent_name': json['parent_name'],
        'attendee_emergency_contact_email': json['attendee_emergency_contact_email'],
        'attendee_emergency_contact_phone': json['attendee_emergency_contact_phone'],
        'active_membership_package_name': json['active_membership_package_name'],
        'session_balance': json['session_balance'],
        'first_attended': !exists(json, 'first_attended') ? undefined : (new Date(json['first_attended'])),
        'last_attended': !exists(json, 'last_attended') ? undefined : (new Date(json['last_attended'])),
        'last_registered': !exists(json, 'last_registered') ? undefined : (new Date(json['last_registered'])),
        'created': (new Date(json['created'])),
    };
}

export function AttendeeReportParamsToJSON(value?: AttendeeReportParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'primary_contact_id': value.primary_contact_id,
        'attendee_full_name': value.attendee_full_name,
        'attendee_first_name': value.attendee_first_name,
        'attendee_last_name': value.attendee_last_name,
        'is_connected': value.is_connected,
        'is_archived': value.is_archived,
        'attendee_age': value.attendee_age,
        'attendee_gender': GenderToJSON(value.attendee_gender),
        'attendee_date_of_birth': value.attendee_date_of_birth,
        'primary_contact_full_name': value.primary_contact_full_name,
        'primary_contact_email': value.primary_contact_email,
        'primary_contact_phones': value.primary_contact_phones,
        'primary_contact_address_place_name': value.primary_contact_address_place_name,
        'parent_name': value.parent_name,
        'attendee_emergency_contact_email': value.attendee_emergency_contact_email,
        'attendee_emergency_contact_phone': value.attendee_emergency_contact_phone,
        'active_membership_package_name': value.active_membership_package_name,
        'session_balance': value.session_balance,
        'first_attended': value.first_attended === undefined ? undefined : (value.first_attended.toISOString()),
        'last_attended': value.last_attended === undefined ? undefined : (value.last_attended.toISOString()),
        'last_registered': value.last_registered === undefined ? undefined : (value.last_registered.toISOString()),
        'created': (value.created.toISOString()),
    };
}

